export default __webpack_public_path__ + "static/news15-93e7eb62a4a9d09ec4e46515b0a48dc8.png";